import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface CurrentHolding {
  ticker: string;
  symbol: string;
  name: string;
  shares: number;
  currentPrice: number;
  currentValue: number;
  averageCost: number;
  totalCost: number;
  gainLoss: number;
  gainLossPercent: number;
  dayChange: number;
  dayChangePercent: number;
  logo: string;
}

export interface CurrentPortfolioSummary {
  totalValue: number;
  totalCost: number;
  totalGainLoss: number;
  totalGainLossPercent: number;
  totalDividends: number;
  totalInterest: number;
  totalReturn: number;
  totalReturnPercent: number;
  dayChange: number;
  dayChangePercent: number;
  lastUpdated: string;
}

export interface CurrentPortfolioResponse {
  summary: CurrentPortfolioSummary;
  holdings: CurrentHolding[];
}

export function useCurrentPortfolio() {
  return useQuery<CurrentPortfolioResponse, Error>({
    queryKey: ["currentPortfolio"],
    queryFn: async () => {
      const { data } = await api.get<CurrentPortfolioResponse>("/portfolio/current-holdings");
      return data;
    },
    refetchOnWindowFocus: true,
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes (holdings don't change often)
    staleTime: 2.5 * 60 * 1000, // 2.5 minutes for fresh portfolio data
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}